"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import style from "../../../style.module.css";
import { tabIcons } from "@/shared/constants/icons";
import { cn } from "@/shared/libs/commonUtils";
import Flex from "@/shared/components/common/Flex";
import Typography from "@/shared/components/common/Typography";
import Grid from "@/shared/components/common/Grid";

export interface TabItemProps {
  title: string;
  icon: string;
  link: string;
}

export default function TabItem({ icon, link, title }: TabItemProps) {
  const pathname = usePathname();
  const tab = pathname.substring(0, pathname.length - 1);

  return (
    <Grid.GridCol
      key={title}
      className={cn(
        style.tab,
        `max-md:h-full max-md:hover:!text-background !py-7 ${
          tab === link &&
          "md:text-primary max-md:hover:!text-background sm:border-b-4 sm:border-primary md:[&_svg]:fill-primary"
        } ${
          !tab &&
          link === "/" &&
          "md:text-primary sm:border-b-4 sm:border-primary md:[&_svg]:fill-primary"
        }`,
        "max-md:hover:!bg-white",
      )}
    >
      <Link href={link} className="w-full">
        <Flex className="max-md:flex-col items-center md:justify-center gap-x-2 max-md:gap-1">
          {tabIcons[icon]}
          <Flex className="items-center gap-x-1">
            <Typography className={cn(style.font, "max-md:text-center")}>
              {title}
            </Typography>
          </Flex>
        </Flex>
      </Link>
    </Grid.GridCol>
  );
}
